import { render } from "./NoteResult.vue?vue&type=template&id=e6a2e2ee"
import script from "./NoteResult.vue?vue&type=script&lang=js"
export * from "./NoteResult.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__